import { render, staticRenderFns } from "./MemberSearchSmall.vue?vue&type=template&id=4d1a8fe8&scoped=true"
import script from "./MemberSearchSmall.vue?vue&type=script&lang=js"
export * from "./MemberSearchSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a8fe8",
  null
  
)

export default component.exports